import Head from 'next/head';
import Header from './header';
import Footer from './footer';
import Newsletter from './newsletter';
import Message from "./message";

const Container = (props)=>{
    const isNewsletter = ()=>{
        if(!props.noNewsletter){
            return <Newsletter/>
        }
    }
    const isMeta = ()=>{
        if(props.meta){
            return props.meta;
        }
    }
    const isFooter = ()=>{
        if(!props.noFooter){
            return <Footer hiddenMobile={props.hiddenMobile}/>
        }
    }
    return(
        <div>
            <Head>
                <title>{props.title}</title>
                { isMeta() }
                <meta property="fb:app_id" content="932906523399540" />
            </Head>
            <Message/>
            <Header menu={props.menu}/>
            <main className={"marginBottom-sm"}>
                {props.children}
            </main>
            {   isNewsletter()  }
            {   isFooter()  }
        </div>
    )
};

export default Container;
